import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import SearchArea from "./area/search";
import ListFunc from "./func/list_func";

const StuSearchList = forwardRef((props: any, ref) => {
  const myProps = {
    list: (inData: any) => { },
    set_content_tab: (inData: any) => { },
    ...props
  };
  let user=useSelector((state:any) => state.user);
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_grade: ["student"],
    "s_class_seq": "",
    "s_stu_grade": "",
    "s_stu_state": "now",
    s_seq: [],
    select_stu_seq: "",
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    s_addon_month_prescribe: "1",
    s_addon_month_prescribe_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_addon_month_prescribe_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_addon_month_prescribe_writer_seq: "",
    s_addon_lecture_time: "1",
  });
  const listOptRef = useRef<any>(listOpt);
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [lectrue_select_arr, set_lectrue_select_arr] = useState<any>([]);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "stu_view",//view
    has_header: true,
    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: false,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
      tab_id: "monthly_prescribe",
      is_first_tab_scroll: true,
      counsel_s_select_date: "",
      month_prescribe_s_subject: "",
    },
    title: "팝업",
    width: "800px",
    height: "80%",
  });

  useEffect(() => {
    get_lecture_select_arr();
  }, []);

  const get_lecture_select_arr = () => {
    let class_list_form = {
      "s_state": "ing",
      "order_id": "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/lecture/list', class_list_form, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_lectrue_select_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const list = (inOptObj: any) => {
    let tmpListOpt = {
      ...listOpt,
      ...inOptObj
    };
    tmpListOpt["sc"] = listAggridRef.current.getListSc();
    setListOpt(tmpListOpt);
    listOptRef.current = tmpListOpt;
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmpListOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = ListFunc.get_list_info_arr({ info_arr: response.data["data"]["info_arr"] });
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (listAggridRef.current) {
            listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
            //select_stu_seq
            if (!strFunc.is_empty(inOptObj["select_stu_seq"])) {
              setTimeout(() => {
                let listNodes = listAggridRef.current.getNodeRows();
                for (let i = 0; i < listNodes.length; i++) {
                  let node = listNodes[i];
                  if (inOptObj["select_stu_seq"] == node.data["a_seq"]) {
                    listNodes[i].setSelected(true);
                  } else {
                    listNodes[i].setSelected(false);
                  }
                }
              }, 100);
            }
          }
          setTimeout(() => {
            onSelectionChanged({
              info_arr: response.data["data"]["info_arr"],
              s_lecture_seq: tmpListOpt.s_stu_lecture_seq
            });
          }, 200);
        } else {

        }
      });
  };

  const open_stu_layer_popup = (inData: any) => {
    let opt_obj = {
      select_stu_info: null,
      ...inData
    };
    let selected_row: any = [];
    if (opt_obj.select_stu_info == null) {
      selected_row = listAggridRef.current.getSelectedRows();
      if (selected_row.length == 0) {
        alert("선택이 없습니다.");
        return false;
      }
      if (selected_row.length != 1) {
        alert("한개만 선택해주세요.");
        return false;
      }
    } else {
      selected_row = [opt_obj.select_stu_info];
    }
    let select_row_data = selected_row[0];
    let select_idx = 0;
    let stu_info_arr: any = [select_row_data];
    let s_row_select_date = listOptRef.current.s_addon_month_prescribe_end_date;
    let tmp_now_ymd = DateFunc.get_date_format(new Date(), "Y-m-d");
    if (s_row_select_date.substring(0, 7) == tmp_now_ymd.substring(0, 7)) {
      s_row_select_date = tmp_now_ymd;
    }
    let month_prescribe_s_subject = "";

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "원생관리",
      "sort": "stu_view",
      write_page_data: {
        is_show: true,
        is_update: true,
        is_view_mode: true,
        is_view_basic: false,
        select_idx: select_idx,
        info_arr: stu_info_arr,
        default_write_info: {},
        tab_id: "monthly_prescribe",
        is_first_tab_scroll: true,
        counsel_s_select_date: s_row_select_date,
        month_prescribe_s_subject: month_prescribe_s_subject,
      },
      width: "98%",
      height: "99%",
      has_header: false,
    });
  };

  const cellRenderOfMonthPrescribe = (params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    let tot_span_style: any = {
      display: "inline-block",
      textAlign: "center",
      lineHeight: "26px",
      height: "26px",
      padding: "0px 8px",
      background: "gray",
      color: "#fff",
      borderRadius: "5px",
    };
    if (key == "row_view_month_prescribe_math") {
      let tmp_is_use_lecture = false;
      if (params.data.lecture_arr && params.data.lecture_arr.length > 0) {
        for (let i = 0; i < params.data.lecture_arr.length; i++) {
          let tmp_lecture_info = params.data.lecture_arr[i];
          if (tmp_lecture_info["a_subject"] == "수학") {
            tmp_is_use_lecture = true;
          }
        }
      }
      if (tmp_is_use_lecture == false) {
        render_str = "x";
        return render_str;
      }
    } else if (key == "row_view_month_prescribe_en") {
      let tmp_is_use_lecture = false;
      if (params.data.lecture_arr && params.data.lecture_arr.length > 0) {
        for (let i = 0; i < params.data.lecture_arr.length; i++) {
          let tmp_lecture_info = params.data.lecture_arr[i];
          if (tmp_lecture_info["a_subject"] == "영어") {
            tmp_is_use_lecture = true;
          }
        }
      }
      if (tmp_is_use_lecture == false) {
        render_str = "x";
        return render_str;
      }
    }

    if (params.data.month_prescribe_arr == undefined) {
      return "";
    }
    if (params.data.month_prescribe_arr.length == 0) {
      return "";
    }
    if (key == "row_view_month_prescribe") {
      if (params.data.month_prescribe_arr.length > 0) {
        let row_mprescribe_arr = params.data.month_prescribe_arr;
        let row_mprescribe_arr_len = row_mprescribe_arr.length;
        let row_success_cnt = 0;
        for (let i = 0; i < row_mprescribe_arr_len; i++) {
          let row_mprescribe = row_mprescribe_arr[i];
          if (row_mprescribe["a_is_success"] == "1") {
            row_success_cnt++;
          }
        }

        if (row_mprescribe_arr_len > 0) {
          tot_span_style["background"] = "#db6c58";
          if (row_success_cnt > 0) {
            tot_span_style["background"] = "#eab358";
            if (row_mprescribe_arr_len == row_success_cnt) {
              tot_span_style["background"] = "#a2b854";
            }
          }
        }
        render_str = (
          <div style={tot_span_style} >
            {row_success_cnt + "/" + row_mprescribe_arr_len}
          </div>
        );
      }
    } else {
      let custom_prescribe_data: any = {
        "math": {
          arr: [],
          cnt: 0,
          success: 0,
        },
        "en": {
          arr: [],
          cnt: 0,
          success: 0,
        },
      };
      for (let i = 0; i < params.data.month_prescribe_arr.length; i++) {
        if (params.data.month_prescribe_arr[i]["a_subject_name"] == "수학") {
          custom_prescribe_data["math"]["arr"].push(params.data.month_prescribe_arr[i]);
          custom_prescribe_data["math"]["cnt"]++;
          if (params.data.month_prescribe_arr[i]["a_is_success"] == "1") {
            custom_prescribe_data["math"]["success"]++;
          }
        } else if (params.data.month_prescribe_arr[i]["a_subject_name"] == "영어") {
          custom_prescribe_data["en"]["arr"].push(params.data.month_prescribe_arr[i]);
          custom_prescribe_data["en"]["cnt"]++;
          if (params.data.month_prescribe_arr[i]["a_is_success"] == "1") {
            custom_prescribe_data["en"]["success"]++;
          }
        }
      }
      if (key == "row_view_month_prescribe_math") {
        if (custom_prescribe_data["math"]["cnt"] > 0) {
          tot_span_style["background"] = "#db6c58";
          if (custom_prescribe_data["math"]["success"] > 0) {
            tot_span_style["background"] = "#eab358";
            if (custom_prescribe_data["math"]["cnt"] == custom_prescribe_data["math"]["success"]) {
              tot_span_style["background"] = "#a2b854";
            }
          }
        }
        render_str = (
          <div style={tot_span_style} >
            {custom_prescribe_data["math"]["success"] + "/" + custom_prescribe_data["math"]["cnt"]}
          </div>
        );
        if (custom_prescribe_data["math"]["cnt"] == 0) {
          render_str = "";
        }
      } else if (key == "row_view_month_prescribe_en") {
        if (custom_prescribe_data["en"]["cnt"] > 0) {
          tot_span_style["background"] = "#db6c58";
          if (custom_prescribe_data["en"]["success"] > 0) {
            tot_span_style["background"] = "#eab358";
            if (custom_prescribe_data["en"]["cnt"] == custom_prescribe_data["en"]["success"]) {
              tot_span_style["background"] = "#a2b854";
            }
          }
        }
        render_str = (
          <div style={tot_span_style} >
            {custom_prescribe_data["en"]["success"] + "/" + custom_prescribe_data["en"]["cnt"]}
          </div>
        );
        if (custom_prescribe_data["en"]["cnt"] == 0) {
          render_str = "";
        }
      }
    }
    return render_str;
  };

  const setSelectFalseAll = () => {
    listAggridRef.current.setSelectFalseAll();
    onSelectionChanged({});
  };

  const cellClickedListener = (params: any) => {
    var key = params.colDef.field;
    if (key == "a_user_name") {
      open_stu_layer_popup({ select_stu_info: params.data });
    }
  }

  const removeSelectStu = (stu_seq: any) => {
    let all_node_rows = listAggridRef.current.getNodeRows();
    for (let i = 0; i < all_node_rows.length; i++) {
      let tmp_seq = all_node_rows[i].data["a_seq"];
      if (tmp_seq == stu_seq) {
        all_node_rows[i].setSelected(false);
      }
    }
    setTimeout(() => {
      onSelectionChanged({});
    }, 100);
  };

  const set_height = (height: any) => {
    if (listAggridRef.current) {
      listAggridRef.current.setHeight(height);
    }
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    list, setSelectFalseAll, removeSelectStu, set_height
  }));


  const cellRenderer = (params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    if (key == "a_user_name") {
      render_str += " " + params.data.a_stu_total_code;
    } else if (key == "row_view_manage") {

    } else if (key == "row_view_class_name") {
      if (params.data.class_arr) {
        let class_name_arr = [];
        for (let i = 0; i < params.data.class_arr.length; i++) {
          class_name_arr.push(params.data.class_arr[i]["class_name"]);
        }
        render_str = class_name_arr.join(" / ");;
      }
    } else if (key == "row_view_month_prescribe"
      || key == "row_view_month_prescribe_math"
      || key == "row_view_month_prescribe_en") {
      render_str = cellRenderOfMonthPrescribe(params);
    } else if (key == "row_view_school_grade") {
      let row_grade_str = params.data.a_stu_grade;
      if (xColumnArr.select_arr.a_stu_grade) {
        for (let i = 0; i < xColumnArr.select_arr.a_stu_grade.length; i++) {
          if (xColumnArr.select_arr.a_stu_grade[i]["value"] == params.data.a_stu_grade) {
            row_grade_str = xColumnArr.select_arr.a_stu_grade[i]["text"];
          }
        }
      }
      let row_school_name = strFunc.cut_str(params.data.a_school_name, 2, "");
      render_str = row_school_name + " " + row_grade_str;
    }
    return render_str;
  };

  const onSelectionChanged = (event: any) => {
    let opt_obj = {
      info_arr: infoArr,
      s_lecture_seq: listOpt.s_stu_lecture_seq,
      ...event
    };
    let selected_row = listAggridRef.current.getSelectedRows();
    let select_seq_arr = [];
    if (selected_row) {
      for (let i = 0; i < selected_row.length; i++) {
        select_seq_arr.push(selected_row[i]["a_seq"]);
      }
    }
    if (select_seq_arr.length == 0) {
      // selected_row = [...opt_obj.info_arr];
      // for (let i = 0; i < selected_row.length; i++) {
      //   select_seq_arr.push(selected_row[i]["a_seq"]);
      // }
    }

    myProps.list({
      "s_stu_user_seq": select_seq_arr,
      "s_stu_info_arr": selected_row,
      "s_lecture_seq": opt_obj.s_lecture_seq,
    });
  };

  return (
    <div>
      <SearchArea
        list={list}
        listOpt={listOpt}
        setListOpt={setListOpt}
        lectrue_select_arr={lectrue_select_arr}
        xColumnArr={xColumnArr}
        set_content_tab={myProps.set_content_tab}
      ></SearchArea>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: false,
          floatingFilter: false,
          rowMultiSelectWithClick: true,
          height: "60vh",
          onGridReady: () => {
            list({});
          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer,
          onSelectionChanged: onSelectionChanged
        }}
      ></ListAggrid>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "stu_view" &&
            <ViewStuLayerPopup
              write_page_data={popupData.write_page_data}
              callback={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewStuLayerPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});

export default StuSearchList;
